import React from "react";


const QUESTION_TYPE_ID_TO_LABEL = {
  "4c524f2f-48de-493e-894f-4f0bd931b4c9": "MCQ",
  "64468292-d741-4e52-893f-0846dd56830d": "Numeric",
  "4ffc711b-2f10-470b-b162-85f2a2f1e220": "Yes/No",
  "30afb159-85d7-490d-afcd-1af9497531ae": "Short answer",
};


const PreScreeningStage = ({
  candidate,
  preQualifyingReport,
  tabLoading,
  formatExpiry,
  isSharedReport,
  setPreselectStage,
  setIsOpen,
}) => {
  if (tabLoading) {
    return (
      <div className="loading-overlay">
        <div className="spinner-border" />
      </div>
    );
  }

  const PRE_SCREENING_STAGE_ID = "3dab71cf-c680-4983-a109-1cff0953999b";

  const stages =
    candidate?.hiring_stages?.filter(
      (s) => s.hiring_stage_id === PRE_SCREENING_STAGE_ID,
    ) || [];

  const latestStage =
    stages.length > 0
      ? stages.reduce((a, b) =>
          new Date(b.created_at) > new Date(a.created_at) ? b : a,
        )
      : null;

  const status = (latestStage?.status?.name || "").trim().toLowerCase();

  return (
    <div className="pre-screening-section">
        {tabLoading ? (
        <div className="loading-overlay" style={{ alignItems: "unset" }}>
            <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
            </div>
        </div>
        ) : (
        <>
            {(() => {
            const PRE_SCREENING_STAGE_ID = "3dab71cf-c680-4983-a109-1cff0953999b";
            const preScreeningStages =
                candidate?.hiring_stages?.filter(
                (stage) => stage.hiring_stage_id === PRE_SCREENING_STAGE_ID,
                ) || [];
            let preScreeningStage = null;
            if (preScreeningStages.length > 0) {
                preScreeningStage = preScreeningStages.reduce((latest, curr) =>
                new Date(curr.created_at) > new Date(latest.created_at)
                    ? curr
                    : latest,
                );
            }
            const status = (preScreeningStage?.status?.name || "")
                .trim()
                .toLowerCase();
            if (status === "completed") {
                return (
                <>
                    <div className="pre-screening-items">
                    {preQualifyingReport?.length > 0 &&
                    preQualifyingReport[0]?.evaluations?.length > 0 ? (
                        <div className="pre-screening-item">
                        <div>
                            <h4>
                            Prescreening score:{" "}
                            {preQualifyingReport?.[0]?.total_score.toFixed(2)}%
                            </h4>
                        </div>

                        <div className="question-block-heading">
                            <h5 className="question-block-heading-question">
                            Question
                            </h5>
                            <h5 className="question-block-heading-options">
                            Suggested answer/options
                            </h5>
                            <h5 className="question-block-heading-answer">
                            Candidate Answer
                            </h5>
                            <h5 className="question-block-heading-score">Score</h5>
                        </div>
                        {preQualifyingReport[0].evaluations.map(
                            (evalItem, idx) => {
                            const typeLabel =
                                QUESTION_TYPE_ID_TO_LABEL[
                                evalItem.question?.question_type_id
                                ] || "Unknown";

                            const isMCQ =
                                evalItem.question?.question_type_id ===
                                "4c524f2f-48de-493e-894f-4f0bd931b4c9";

                            // correct answer text
                            const correctAnswer =
                                evalItem.question?.meta_data
                                ?.required_answer_text ||
                                evalItem.question?.meta_data
                                ?.required_option_text ||
                                null;

                            // candidate answer text
                            const candidateAnswer =
                                evalItem.answer_text ||
                                evalItem.selected_option?.option_text ||
                                null;

                            // check correctness
                            const isCorrect =
                                candidateAnswer &&
                                correctAnswer &&
                                candidateAnswer.trim().toLowerCase() ===
                                correctAnswer.trim().toLowerCase();

                            return (
                                <>
                                {evalItem.question && (
                                    <div key={evalItem.id} className="question-block">
                                    <div className="question-block-details">
                                        <div className="question-block-question">
                                        <h5>{typeLabel}</h5>
                                        <p>{evalItem.question?.question_text}</p>
                                        </div>
                                    </div>
                                    <div className="d-flex flex-wrap">
                                        {isMCQ ? (
                                        <div className="d-flex flex-wrap">
                                            {evalItem.question?.options?.map(
                                            (opt) => {
                                                const isCorrect =
                                                opt.option_text
                                                    .trim()
                                                    .toLowerCase() ===
                                                (
                                                    evalItem.question?.meta_data
                                                    ?.required_option_text || ""
                                                )
                                                    .trim()
                                                    .toLowerCase();

                                                return (
                                                <p
                                                    key={opt.id}
                                                    style={{
                                                    fontWeight: isCorrect
                                                        ? "700"
                                                        : "400",
                                                    color: isCorrect
                                                        ? "green"
                                                        : "",
                                                    marginRight: "8px",
                                                    fontSize: "12px",
                                                    }}
                                                >
                                                    {opt.option_text}
                                                </p>
                                                );
                                            },
                                            )}
                                        </div>
                                        ) : (
                                        <div>
                                            <p style={{ fontSize: "12px" }}>
                                            {evalItem.question?.meta_data
                                                ?.required_answer_text ||
                                                evalItem.question?.meta_data
                                                ?.required_option_text ||
                                                "N/A"}
                                            </p>
                                        </div>
                                        )}
                                    </div>
                                    <div className="question-block-answer">
                                        {isMCQ ? (
                                        <div>
                                            <p>{candidateAnswer || "N/A"}</p>
                                        </div>
                                        ) : (
                                        <div>
                                            <p>{candidateAnswer || "N/A"}</p>
                                        </div>
                                        )}
                                    </div>
                                    <div className="question-block-score">
                                        <p>
                                            {evalItem.score ? evalItem.score : 0}/
                                            {evalItem.question?.score || 0}
                                        </p>
                                    </div>
                                </div>
                                )}
                                </>
                            );
                            },
                        )}
                        </div>
                    ) : (
                        <p>Pre-Screening test not assigned or not completed yet</p>
                    )}
                    </div>
                </>
                );
            } else if (status === "assigned" || status === "scheduled") {
                return (
                <p>
                    Pre-Screening test assigned but not completed yet Expiry:{" "}
                    {formatExpiry(preScreeningStage?.expire_at)}
                </p>
                );
            } else if (status === "ongoing") {
                return (
                <p>
                    Pre-Screening test Ongoing not completed yet Expiry:{" "}
                    {formatExpiry(preScreeningStage?.expire_at)}
                </p>
                );
            } else if (!status || status === "not scheduled") {
                return (
                !isSharedReport && (
                    <button
                    className="candidate-assessment-calling"
                    onClick={() => {
                        setPreselectStage("Pre Screening");
                        setIsOpen(true);
                    }}
                    >
                    Assign Pre-Screening Test
                    </button>
                )
                );
            } else if (status === "expired") {
                return (
                <>
                    <p style={{ color: "red" }}>Pre-Screening Expired</p>
                    &nbsp;
                    {!isSharedReport && (
                    <button
                        className="candidate-assessment-calling"
                        onClick={() => {
                        setPreselectStage("Pre Screening");
                        setIsOpen(true);
                        }}
                    >
                        Assign Pre-Screening Test
                    </button>
                    )}
                </>
                );
            } else if (status === "failed") {
                return (
                <>
                    <p style={{ color: "red" }}>Pre-Screening Failed</p>
                    &nbsp;
                    {!isSharedReport && (
                    <button
                        className="candidate-assessment-calling"
                        onClick={() => {
                        setPreselectStage("Pre Screening");
                        setIsOpen(true);
                        }}
                    >
                        Assign Pre-Screening Test
                    </button>
                    )}
                </>
                );
            } else {
                return <p>Pre-Screening sent to candidate</p>;
            }
            })()}
        </>
        )}
    </div>
  );
};

export default PreScreeningStage;
